
<template>
    <svg
        :height='height'
        :width='width'
        :fill="fill"
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
        version="1.1"
        x="0px"
        y="0px"
        viewBox="0 0 48 48"
        enable-background="new 0 0 48 48"
        xml:space="preserve">
        <g>
            <path d="M42.843,39.073L25.55,6h-3.1L5.157,39.073c-0.323,0.617-0.299,1.369,0.061,1.961C5.577,41.63,6.233,42,6.93,42H41.07   c0.696,0,1.353-0.37,1.71-0.963C43.142,40.442,43.166,39.69,42.843,39.073z M23,21h2v10h-2V21z M24,35.5   c-0.827,0-1.5-0.673-1.5-1.5s0.673-1.5,1.5-1.5s1.5,0.673,1.5,1.5S24.827,35.5,24,35.5z">
            </path>
        </g>
    </svg>
</template>

<script>
export default {
  name: 'EmergencyIcon',
  props: {
    width: {
      type: Number,
      default: 30,
      required: false,
    },
    height: {
      type: Number,
      default: 30,
      required: false,
    },
    fill: {
      type: String,
      default: 'white',
      required: false,
    },
  },
};
</script>

<style lang="css" scoped></style>
